import moment from 'moment-timezone'
import { languages, mapLanguageToMoment } from 'i18n'
import {
  DEFAULT_DATETIME_FORMAT,
  DEFAULT_DATE_FORMAT,
  DEFAULT_TIME_FORMAT,
  DATETIME_TIMEZONE_FORMAT,
} from 'app-constants'

export function parseDateTime(date) {
  if (date) {
    // First try default format
    let parsedDate = moment(date, DEFAULT_DATETIME_FORMAT)
    if (parsedDate.isValid()) {
      return parsedDate
    }

    parsedDate = moment(date, moment.ISO_8601)
    if (parsedDate.isValid()) {
      return parsedDate
    }

    // Try to parse with current locale. If no luck, try other locales.
    parsedDate = moment(date, 'l')
    if (parsedDate.isValid()) {
      return parsedDate
    }

    for (const locale in languages) {
      const possiblyParsedDate = moment(date, [DATETIME_TIMEZONE_FORMAT, 'l'], mapLanguageToMoment(locale))

      if (possiblyParsedDate.isValid()) {
        return possiblyParsedDate
      }
    }

    throw new Error('Invalid date')
  }
  return null
}

/**
 * Format date time value
 * @param  {string} date   Date string in ISO 8601
 * @param  {string} format
 * @return {string}
 */
function format(date, format, timezone) {
  const dateObject = moment(date).tz(timezone)
  if (!date || !dateObject || !dateObject.isValid()) {
    return ''
  }
  return dateObject.format(format)
}

export function formatDateTime(date, timezone = moment.tz.guess()) {
  return format(date, DEFAULT_DATETIME_FORMAT, timezone)
}

export function formatDate(date, timezone = moment.tz.guess()) {
  return format(date, DEFAULT_DATE_FORMAT, timezone)
}

export function formatDateTimeTimezone(date, timezone = moment.tz.guess()) {
  return format(date, DATETIME_TIMEZONE_FORMAT, timezone)
}

export function formatTime(date, timezone = moment.tz.guess()) {
  return format(date, DEFAULT_TIME_FORMAT, timezone)
}

export function earlierDate(firstDate, secondDate) {
  if (!firstDate) {
    return secondDate
  }
  if (!secondDate) {
    return firstDate
  }
  return new Date(firstDate).getTime() <= new Date(secondDate).getTime()
    ? firstDate
    : secondDate
}

export function parseDateTimeWithTimezone(date) {
  if (date) {
    // First try default format

    const parsedDate = moment(date, DEFAULT_DATETIME_FORMAT)
    const parsedTimeZone = moment(date, DATETIME_TIMEZONE_FORMAT).utcOffset()
    if (parsedDate.isValid()) {
      return parsedTimeZone
    }

    throw new Error('Invalid date')
  }
  return null
}
